import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoanDetailPage from "./LoanDetail";
import LoanDashboard from "./LoanDashboard";
import { fetchLoanDetail } from "../../actions/loanDetailAction";
import Loader from "../Common/Loader";
import { SCCustomerNavigation } from "./css";
import { NavWithComponent } from "../Nav";
import { RootState } from "../../reducers";

const ViewLoan = ({ match }) => {
  const dispatch = useDispatch();
  
  const { loanDetail, loading, error } = useSelector((state: RootState) => ({
    loanDetail: state.loanDetail.loanDetailData,
    loading: state.loanDetail.loading,
    error: state.loanDetail.error
  }));

  useEffect(() => {
    dispatch(fetchLoanDetail(match.params.id));
  }, [dispatch, match.params.id]);

  // Object for loan Dashboard
  const loanDashBoardData = {
    loanName: loanDetail?.name,
    storeName: loanDetail?.storeName,
    paymentFrequency: loanDetail?.estimateRepaymentRemaining,
    paidAmount: loanDetail?.paidLoanAmount,
    balanceRemaining: loanDetail?.balanceRemaining,
    loanStatus: loanDetail?.status?.toLowerCase(),
    nextRepaymentDate: loanDetail?.nextRepaymentDate,
    nextRepaymentAmount: loanDetail?.nextRepaymentAmount,
    icon: ""
  };
  if (error != null) {
    return <div>Error! {error.message}</div>;
  }

  if (loading) {
    return <Loader text="Loading...." />;
  }

  return (
    <SCCustomerNavigation>
      <NavWithComponent activePage="/my-loans" previousPagePath="/my-loans" title="Loan Details" />
      <LoanDashboard loanDashBoardData={loanDashBoardData} />
      <LoanDetailPage loanDetailPageData={loanDetail} />
    </SCCustomerNavigation>
  );
};

export default ViewLoan;
